import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { ErrorResponse } from "../../models/apiResponse";
import { PaymentMethod } from "../../models/payment";

const useQueryPaymentMethods = ({
  corporateId,
  enabled = true,
  authorisation = "",
}: {
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/payment-method`],
    () =>
      fetchApi(`corporate-subsidiary/${corporateId}/payment-method`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      }).get<PaymentMethod[] | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 3,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryPaymentMethods;
